
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Montpellier dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO est une agence Google Ads à Montpellier certifiée Google Partner, aide les entreprises montpelliéraines à booster leur visibilité en ligne et à gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Montpellier dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO est une agence Google Ads à Montpellier certifiée Google Partner, aide les entreprises montpelliéraines à booster leur visibilité en ligne et à gagner de nouveaux clients.",
        },
      ],
    };
  },
};
